'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fal';
var iconName = 'laptop-code';
var width = 640;
var height = 512;
var aliases = [];
var unicode = 'f5fc';
var svgPathData = 'M372.7 299.3C375.8 302.4 379.9 304 384 304s8.188-1.562 11.31-4.688l64-64c6.25-6.25 6.25-16.38 0-22.62l-64-64c-6.25-6.25-16.38-6.25-22.62 0s-6.25 16.38 0 22.62L425.4 224l-52.69 52.69C366.4 282.9 366.4 293.1 372.7 299.3zM267.3 148.7c-6.25-6.25-16.38-6.25-22.62 0l-64 64c-6.25 6.25-6.25 16.38 0 22.62l64 64C247.8 302.4 251.9 304 256 304s8.188-1.562 11.31-4.688c6.25-6.25 6.25-16.38 0-22.62L214.6 224l52.69-52.69C273.6 165.1 273.6 154.9 267.3 148.7zM80 352C88.84 352 96 344.8 96 336V96c0-17.66 14.36-32 32-32h384c17.64 0 32 14.34 32 32v240c0 8.844 7.156 16 16 16s16-7.156 16-16V96c0-35.28-28.7-64-64-64H128C92.7 32 64 60.72 64 96v240C64 344.8 71.16 352 80 352zM624 384h-608C7.25 384 0 391.3 0 400V416c0 35.25 28.75 64 64 64h512c35.25 0 64-28.75 64-64v-16C640 391.3 632.8 384 624 384zM576 448H64c-17.64 0-32-14.36-32-32h576C608 433.6 593.6 448 576 448z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faLaptopCode = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;